module.exports = __webpack_public_path__ + "static/img/ME.460e0e44.svg";